import { render, staticRenderFns } from "./ResourceMarketingInfo.vue?vue&type=template&id=34a9216e"
import script from "./ResourceMarketingInfo.vue?vue&type=script&lang=js"
export * from "./ResourceMarketingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports